// Small reusable form primitives for the admin dashboard

export function TextInput({ label, value, onChange, placeholder, testid, type = "text" }) {
  return (
    <label className="block">
      {label && (
        <span className="overline text-[#5c5c5c] block mb-2">{label}</span>
      )}
      <input
        data-testid={testid}
        type={type}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full bg-transparent border-b border-[#d8d4ce] focus:border-[#a66e4b] outline-none py-2 text-[#1a1a1a] font-light text-sm"
      />
    </label>
  );
}

export function TextArea({ label, value, onChange, rows = 4, placeholder, testid }) {
  return (
    <label className="block">
      {label && <span className="overline text-[#5c5c5c] block mb-2">{label}</span>}
      <textarea
        data-testid={testid}
        rows={rows}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full bg-[#f9f8f6] border border-[#e5e2dd] focus:border-[#a66e4b] outline-none p-3 text-[#1a1a1a] font-light text-sm resize-y"
      />
    </label>
  );
}

export function StringList({ label, items = [], onChange, testid }) {
  const update = (i, v) => {
    const copy = [...items];
    copy[i] = v;
    onChange(copy);
  };
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
  const add = () => onChange([...items, ""]);
  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= items.length) return;
    const copy = [...items];
    [copy[i], copy[j]] = [copy[j], copy[i]];
    onChange(copy);
  };
  return (
    <div data-testid={testid}>
      {label && <div className="overline text-[#5c5c5c] mb-3">{label}</div>}
      <ul className="space-y-2">
        {items.map((it, i) => (
          <li key={i} className="flex gap-2 items-start">
            <span className="text-[#7a7570] font-serif-display italic text-xl leading-none pt-1 w-6">
              {i + 1}
            </span>
            <textarea
              rows={1}
              value={it}
              onChange={(e) => update(i, e.target.value)}
              className="flex-1 bg-[#f9f8f6] border border-[#e5e2dd] focus:border-[#a66e4b] outline-none p-2 text-[#1a1a1a] font-light text-sm resize-y"
            />
            <div className="flex flex-col gap-1">
              <button
                type="button"
                onClick={() => move(i, -1)}
                className="text-[10px] text-[#7a7570] hover:text-[#1a1a1a] px-1"
                aria-label="aukštyn"
              >
                ↑
              </button>
              <button
                type="button"
                onClick={() => move(i, +1)}
                className="text-[10px] text-[#7a7570] hover:text-[#1a1a1a] px-1"
                aria-label="žemyn"
              >
                ↓
              </button>
            </div>
            <button
              type="button"
              onClick={() => remove(i)}
              className="text-[11px] text-[#e57373] hover:text-[#ff8a8a] px-2"
            >
              ×
            </button>
          </li>
        ))}
      </ul>
      <button
        type="button"
        onClick={add}
        className="mt-3 text-[11px] uppercase tracking-[0.22em] text-[#a66e4b] hover:text-[#d09a72]"
      >
        + Pridėti
      </button>
    </div>
  );
}

export function Card({ title, children, actions }) {
  return (
    <section className="border border-[#e5e2dd] bg-white p-6 md:p-8">
      {(title || actions) && (
        <header className="flex items-center justify-between mb-6">
          {title && (
            <h3 className="font-serif-display italic text-[#a66e4b] text-xl">
              {title}
            </h3>
          )}
          {actions}
        </header>
      )}
      {children}
    </section>
  );
}
